import { useCallback } from 'react'

import { useDispatch } from 'react-redux'

import { CollectionUUID } from '@library/menu-service'

import { actionTypes } from 'actions/actionTypes'
import { recipeCollectionSelected } from 'actions/trackingKeys'
import { useSelectCollection } from 'hooks/menu-collections'

/**
 * Compared to useSelectCollection, this hook tracks collection changes using TRACKING action
 */
export const useChangeCollectionById = () => {
  const selectCollection = useSelectCollection()
  const dispatch = useDispatch()

  return useCallback(
    (collectionId: CollectionUUID) => {
      selectCollection(collectionId, (oldCollection, newCollection) => {
        if (newCollection && oldCollection?.id !== newCollection.id) {
          dispatch({
            type: actionTypes.TRACKING,
            trackingData: {
              actionType: recipeCollectionSelected,
              collectionId: newCollection.id,
              fromCollectionId: oldCollection?.id || null,
            },
          })
        }
      })
    },
    [dispatch, selectCollection],
  )
}
